module.exports = __webpack_public_path__ + "static/Callective-fb8ca93ea9839d8ee733d76491b95ec3.jpg";